<template>
    <div class="confirmation">
        <h2 class="confirmation__title">
            {{ title }}
        </h2>
        <div class="confirmation__text">
            <slot />
        </div>
        <div class="confirmation__buttons --modal-buttons">
            <hh-btn type="cancel"
                    class="confirmation__buttons__button confirmation__buttons__button--cancel"
                    icon-class="fas fa-undo"
                    :icon-location="iconLocation"
                    text="Cancel"
                    @click="$emit('cancel', $event)" />
            <hh-btn :type="confirmButtonType"
                    class="confirmation__buttons__button confirmation__buttons__button--confirm"
                    :icon-class="confirmIconClass"
                    :icon-location="iconLocation"
                    :text="confirmText"
                    @click="$emit('confirm', $event)" />
        </div>
    </div>
</template>

<script>

export default {

    props: {
        title: {
            type: String,
            required: true,
        },
        confirmText: {
            type: String,
            default: 'OK',
        },
        confirmIconClass: {
            type: String,
            default: 'far fa-check-circle',
        },
        confirmButtonType: {
            type: String,
            default: 'cta-danger',
        },
        iconLocation: {
            type: String,
            default: 'pre',
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.confirmation {

    @include element('title') {
        margin: 0 0 0.6em 0;
        line-height: 1.2em;
    }

    @include element('buttons') {
        padding-top: 10px;
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: space-evenly;
        padding-bottom: 5px;

        @include bp-min-mid {
            flex-direction: row;
            width: auto;
        }

        @include element('button') {
            width: 100%;
            min-width: 140px;

            @include bp-min-small {
                width: auto;
            }
        }
    }
}

</style>
